import createReactComponent from '../createReactComponent';
export default createReactComponent('lamp', 'IconLamp', [
  ['path', { d: 'M9 20h6', key: 'svg-0' }],
  ['path', { d: 'M12 20v-8', key: 'svg-1' }],
  ['path', { d: 'M5 12h14l-4 -8h-6z', key: 'svg-2' }],
]);
